import { UNBREAKABLE_SEPARATOR } from '@src/constants/unbreakableSeparator';

export const ServiceBannerInfoSheetTexts = {
  title: 'Сравни — сервис №1',
  content: `На сервис Сравни приходится наибольшая доля успешного подбора займа в сравнении ${UNBREAKABLE_SEPARATOR}с другими сервисами подбора и сравнения микрозаймов по результатам опросов в 4-м квартале 2024г. в городах-миллионниках.`,
  description: `Исследование проведено${UNBREAKABLE_SEPARATOR}ООО «Ипсос Комкон»`,
  buttonText: 'Понятно',
};
